import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedAirportSelectorDesktop } from '../../AirportSelector';
import { ConnectedSegmentArrival } from '../Segment/SegmentArrival';
import { LegType, EntryPoint } from '../../../models';
import { LocationAutocompleteSource } from '../../LocationAutocomplete/LocationAutocompleteSource';
import { InspirationalSearchSelectorSource } from '../../InspirationalSearchSelector/InspirationalSearchSelectorSource';
import { PreviousSearchesSourceDesktop } from '../../PreviousSearches/PreviousSearchesSourceDesktop';
import { TopDestinationsSourceDesktop } from '../../TopDestinations/TopDestinationsSourceDesktop';
import { useSegmentContext } from '../Segment/SegmentManager/Context';

export const ArrivalDesktop = ({ fieldFocused, onChangeFocus, isHotel }) => {
    const { segment } = useSegmentContext();
    const { id } = segment;

    const getArrivalAirportSelectorSources = (activeProduct, isMultipleSegments) => {
        const departureOrArrival = LegType.ARRIVAL;
        const maxPreviousSearches = 4;
        const locationAutocomplete = LocationAutocompleteSource({
            departureOrArrival,
            activeProduct,
        });
        if (activeProduct === EntryPoint.FLIGHTS) {
            const previousSearches = PreviousSearchesSourceDesktop({ maxPreviousSearches, activeProduct });
            const topDestinations = TopDestinationsSourceDesktop({ id, activeProduct });
            if (isMultipleSegments) {
                return [locationAutocomplete, previousSearches, topDestinations];
            }
            const inspirationalSearch = InspirationalSearchSelectorSource();
            return [locationAutocomplete, previousSearches, inspirationalSearch, topDestinations];
        }
        return [locationAutocomplete];
    };

    return (
        <ConnectedSegmentArrival segmentId={id}>
            {({ error, value, setValue, activeProduct, isMultipleSegments, isDisabled }) => (
                <ConnectedAirportSelectorDesktop
                    departureOrArrival={LegType.ARRIVAL}
                    validationError={error}
                    isHotel={isHotel}
                    value={value}
                    setValue={setValue}
                    sources={getArrivalAirportSelectorSources(activeProduct, isMultipleSegments)}
                    onChangeFocus={onChangeFocus}
                    focus={fieldFocused === LegType.ARRIVAL}
                    isDisabled={isDisabled}
                />
            )}
        </ConnectedSegmentArrival>
    );
};

ArrivalDesktop.propTypes = {
    fieldFocused: PropTypes.string,
    onChangeFocus: PropTypes.func.isRequired,
    isHotel: PropTypes.bool,
};

ArrivalDesktop.defaultProps = {
    fieldFocused: null,
    isHotel: false,
};
